import { render, staticRenderFns } from "./CharacterInfo.vue?vue&type=template&id=dffa1844&scoped=true"
import script from "./CharacterInfo.vue?vue&type=script&lang=ts"
export * from "./CharacterInfo.vue?vue&type=script&lang=ts"
import style0 from "./CharacterInfo.vue?vue&type=style&index=0&id=dffa1844&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dffa1844",
  null
  
)

export default component.exports